// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_82a27a64","icon":"_d037225c","vipText":"_33242fc5"};